import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-calendar-minus-02',
  imports: [],
  templateUrl: './calendar-minus-02.html',
  styleUrl: './calendar-minus-02.scss',
})
export class CalendarMinus02 {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
